import { createActions } from 'redux-actions';
import { ShopDetails } from '../../models';

export const {
  shop: {
    getStoreDetails, receiveStoreDetails, getOrder, receiveOrder, createOrder, createOrderFailure, setBusinessName, setStoreDetails,
  },
}: any = createActions({
  SHOP: {
    GET_STORE_DETAILS: () => ({
      isFetchingStoreDetails: true,
    }),
    RECEIVE_STORE_DETAILS: (details) => ({
      details,
    }),
    GET_ORDER: () => ({
      isFetchingOrder: true,
    }),
    RECEIVE_ORDER: (order) => ({
      isFetchingOrder: false,
      order,
    }),
    CREATE_ORDER: () => ({
      isCreating: true,
      isCreatingOrderError: false,
    }),
    CREATE_ORDER_FAILURE: () => ({
      isCreating: false,
      isCreatingOrderError: true,
    }),
    SET_BUSINESS_NAME: (businessName: string) => ({
      businessName,
    }),
    SET_STORE_DETAILS: (details: ShopDetails, isMissingDetails: boolean) => ({
      isFetchingStoreDetails: false,
      details,
      isMissingDetails,
    }),
  },
});
